import { useAwaitQuery } from '@/common/hooks/useAwaitQuery';
import { useCartContext } from '@/context/cart';
import { BrowserPersistence } from '@/util';
import { gql, useMutation } from '@apollo/client';

let pendingEnsureCartIdPromise = null;

export const useEnsureCartId = () => {
  const [fetchCartId] = useMutation(CREATE_CART_MUTATION);
  const fetchCartDetails = useAwaitQuery(CART_DETAILS_QUERY);

  const [{ cartId }, cartActions] = useCartContext();

  const handleEnsureCartId = async () => {
    if (pendingEnsureCartIdPromise) {
      return pendingEnsureCartIdPromise;
    }

    const ensureCartIdPromise = (async () => {
      if (!cartId) {
        try {
          await cartActions.getCartDetails({
            fetchCartId,
            fetchCartDetails,
          });
        } catch (error) {
          console.error(error);
        }
      }

      const storageCartId = new BrowserPersistence().getItem('cartId');

      return cartId || storageCartId || '';
    })().finally(() => {
      pendingEnsureCartIdPromise = null;
    });

    pendingEnsureCartIdPromise = ensureCartIdPromise;

    return ensureCartIdPromise;
  };

  return { handleEnsureCartId };
};

const CREATE_CART_MUTATION = gql`
  mutation createCart {
    cartId: createEmptyCart
  }
`;

const CART_DETAILS_QUERY = gql`
  query checkUserIsAuthed($cartId: String!) {
    cart(cart_id: $cartId) {
      id
    }
  }
`;
